import { environment } from 'environments/environment';

export const PropertieUtil = {

    ip_servidor_ws: environment.ip_servidor_ws,
    val_servidor: environment.val_servidor,
    // val_servidor_login: environment.val_servidor_login,
    val_servidor_upload_drive: environment.val_servidor_upload_drive,

    val_servidor_marcacion_intranet: environment.val_servidor_marcacion_intranet,

    val_url_archivos: environment.val_url_archivos,

    val_id_folder_google_drive_gestion_solicitudes: environment.val_id_folder_google_drive_gestion_solicitudes,
    val_id_folder_google_drive_gestion_solicitudes_comision_servicio: environment.val_id_folder_google_drive_gestion_solicitudes_comision_servicio,
    val_id_folder_google_drive_gestion_solicitudes_licencias: environment.val_id_folder_google_drive_gestion_solicitudes_licencias,
    val_id_folder_google_drive_gestion_solicitudes_permisos: environment.val_id_folder_google_drive_gestion_solicitudes_permisos,
    val_id_folder_google_drive_gestion_solicitudes_salud: environment.val_id_folder_google_drive_gestion_solicitudes_salud,
    val_id_folder_google_drive_gestion_solicitudes_trabajo_remoto: environment.val_id_folder_google_drive_gestion_solicitudes_trabajo_remoto,
    val_id_folder_google_drive_gestion_solicitudes_compensacion: environment.val_id_folder_google_drive_gestion_solicitudes_compensacion,
    val_id_folder_google_drive_gestion_solicitudes_medida_cautelar: environment.val_id_folder_google_drive_gestion_solicitudes_medida_cautelar,
    val_id_folder_google_drive_gestion_solicitudes_teletrabajo: environment.val_id_folder_google_drive_gestion_solicitudes_teletrabajo,

    ip_fija_panama: environment.ip_fija_panama,
    ip_fija_olaechea: environment.ip_fija_olaechea,
    ip_fija_huarmaca: environment.ip_fija_huarmaca,

    val_entidad: environment.val_entidad,

    ws_abast_contratossuscritosws: "abast_contratossuscritosws/",

    ws_acceso: "accesows/",
    ws_contenedor: "contenedorws/",
    ws_controlasistencia: "controlasistenciaws/",
    ws_dependencia: "dependenciaws/",
    ws_desplazamiento_personal: "desplazamientopersonalws/",
    ws_documento: "documentows/",
    ws_encargatura: "encargaturaws/",
    ws_marcacion_personal: "marcacionpersonalws/",
    ws_personal: "personalws/",
    ws_reporte_documento: "reportedocumentows/",
    ws_reporte_marcaciones: "reportemarcacionws/",
    ws_reporte_personal: "reportepersonalws/",
    ws_sede: "sedews/",
    ws_tablamaestra: "tablamaestraws/",
    ws_ubigeo: "ubigeows/",
    ws_utilitarios: "utilitariosws/",
    ws_vacacion: "vacacionws/",
    ws_gestion: "gestionws/"

    

    //Utilitarios
    //node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng build --prod=true
};
